import { DocsBlockDefinition } from "../../model/docs/blocks/definition/SDKDocsBlockDefinition";
import { DocsBlockItemDefinition } from "../../model/docs/blocks/definition/SDKDocsBlockItemDefinition";
import { DocsBlockLayout } from "../../model/docs/blocks/definition/SDKDocsBlockLayout";
import { DocsBlockOnboarding } from "../../model/docs/blocks/definition/SDKDocsBlockOnboarding";
import { DocsBlockVariant } from "../../model/docs/blocks/definition/SDKDocsBlockVariant";
import { DocsBlockAssetPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockAssetProperty";
import { DocsBlockAssetPropertyPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockAssetPropertyProperty";
import { DocsBlockBooleanPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockBooleanProperty";
import { DocsBlockCodePropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockCodeProperty";
import { DocsBlockCodeSandboxPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockCodeSandboxProperty";
import { DocsBlockComponentPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockComponentProperty";
import { DocsBlockComponentPropertyPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockComponentPropertyProperty";
import { DocsBlockDividerPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockDividerProperty";
import { DocsBlockEmbedUrlPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockEmbedUrlProperty";
import { DocsBlockFigmaComponentPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockFigmaComponentProperty";
import { DocsBlockFigmaNodePropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockFigmaNodeProperty";
import { DocsBlockImagePropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockImageProperty";
import { DocsBlockMarkdownPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockMarkdownProperty";
import { DocsBlockMultiSelectPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockMultiSelectProperty";
import { DocsBlockNumberPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockNumberProperty";
import { DocsBlockRichTextEditorPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockRichTextEditorProperty";
import { DocsBlockRichTextPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockRichTextProperty";
import { DocsBlockSingleSelectPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockSingleSelectProperty";
import { DocsBlockStorybookPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockStorybookProperty";
import { DocsBlockTablePropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockTableProperty";
import { DocsBlockTextPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockTextProperty";
import { DocsBlockTokenPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockTokenProperty";
import { DocsBlockTokenPropertyPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockTokenPropertyProperty";
import { DocsBlockTokenTypePropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockTokenTypeProperty";
import { DocsBlockUrlPropertyDefinition, } from "../../model/docs/blocks/properties/SDKDocsBlockUrlProperty";
import { DocsBlockBehaviorDataType } from "../../model/enums/SDKDocsBlockBehaviorDataType";
import { DocsBlockItemPropertyType } from "../../model/enums/SDKDocsBlockItemPropertyType";
import { DocsBlockItemVariantLayoutType } from "../../model/enums/SDKDocsBlockItemVariantLayoutType";
export class DocsBlockBuilder {
    /** Create a layout definition with selected properties (or sublayouts) stacked into column */
    columnLayout(children, options) {
        const propOrLayout = children.map((c) => {
            // From property definition, extract prop id
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line no-prototype-builtins
            if (c.hasOwnProperty("id")) {
                return c.id;
            }
            // Otherwise this is layout definition, just return it
            return c;
        });
        return new DocsBlockLayout({
            type: DocsBlockItemVariantLayoutType.column,
            columnResizing: options === null || options === void 0 ? void 0 : options.resizing,
            columnAlign: options === null || options === void 0 ? void 0 : options.align,
            gap: options === null || options === void 0 ? void 0 : options.gap,
            children: propOrLayout,
        });
    }
    /** Create a layout definition with selected properties (or sublayouts) stacked into row */
    rowLayout(children, options) {
        const propOrLayout = children.map((c) => {
            // From property definition, extract prop id
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line no-prototype-builtins
            if (c.hasOwnProperty("id")) {
                return c.id;
            }
            // Otherwise this is layout definition, just return it
            return c;
        });
        return {
            type: DocsBlockItemVariantLayoutType.row,
            gap: options === null || options === void 0 ? void 0 : options.gap,
            children: propOrLayout,
        };
    }
    /** Create an item variant to render the item in a specific way */
    variantUsingCustomLayout(options) {
        var _a, _b, _c;
        return new DocsBlockVariant({
            id: options.id,
            name: options.name,
            image: options.image,
            layout: options.layout,
            description: (_a = options.description) !== null && _a !== void 0 ? _a : undefined,
            maxColumns: (_b = options.maxColumns) !== null && _b !== void 0 ? _b : 1,
            defaultColumns: (_c = options.defaultColumns) !== null && _c !== void 0 ? _c : 1,
        });
    }
    /** Create and item variant to render the item with default layout (all properties will be stacked into a single column) */
    variantUsingDefaultLayout(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return new DocsBlockVariant({
            id: options.id,
            name: options.name,
            image: options.image,
            layout: this.columnLayout(options.properties),
            description: (_a = options.description) !== null && _a !== void 0 ? _a : undefined,
            maxColumns: (_b = options.maxColumns) !== null && _b !== void 0 ? _b : 1,
            defaultColumns: (_c = options.defaultColumns) !== null && _c !== void 0 ? _c : 1,
            appearance: {
                isBordered: (_e = (_d = options.appearance) === null || _d === void 0 ? void 0 : _d.isBordered) !== null && _e !== void 0 ? _e : undefined,
                hasBackground: (_g = (_f = options.appearance) === null || _f === void 0 ? void 0 : _f.hasBackground) !== null && _g !== void 0 ? _g : undefined,
                isEditorPresentationDifferent: (_j = (_h = options.appearance) === null || _h === void 0 ? void 0 : _h.isEditorPresentationDifferent) !== null && _j !== void 0 ? _j : undefined,
                showBlockHeaderInEditor: (_l = (_k = options.appearance) === null || _k === void 0 ? void 0 : _k.showBlockHeaderInEditor) !== null && _l !== void 0 ? _l : undefined,
            },
        });
    }
    /** Create and item variant to render the item with default layout (all properties will be stacked into a single column) */
    defaultVariantUsingDefaultLayout(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return new DocsBlockVariant({
            id: "default",
            name: (_a = options.name) !== null && _a !== void 0 ? _a : "Default",
            image: (_b = options.image) !== null && _b !== void 0 ? _b : undefined,
            description: (_c = options.description) !== null && _c !== void 0 ? _c : undefined,
            layout: this.columnLayout(options.properties),
            maxColumns: (_d = options.maxColumns) !== null && _d !== void 0 ? _d : 1,
            defaultColumns: (_e = options.defaultColumns) !== null && _e !== void 0 ? _e : 1,
            appearance: {
                isBordered: (_g = (_f = options.appearance) === null || _f === void 0 ? void 0 : _f.isBordered) !== null && _g !== void 0 ? _g : undefined,
                hasBackground: (_j = (_h = options.appearance) === null || _h === void 0 ? void 0 : _h.hasBackground) !== null && _j !== void 0 ? _j : undefined,
                isEditorPresentationDifferent: (_l = (_k = options.appearance) === null || _k === void 0 ? void 0 : _k.isEditorPresentationDifferent) !== null && _l !== void 0 ? _l : undefined,
                showBlockHeaderInEditor: (_o = (_m = options.appearance) === null || _m === void 0 ? void 0 : _m.showBlockHeaderInEditor) !== null && _o !== void 0 ? _o : undefined,
            },
        });
    }
    /** Create block item with a single variant of rendering */
    singleVariantItem(configuration) {
        var _a, _b;
        const block = new DocsBlockItemDefinition({
            properties: [],
            appearance: {
                isBordered: (_a = configuration.appearance) === null || _a === void 0 ? void 0 : _a.isBordered,
                hasBackground: (_b = configuration.appearance) === null || _b === void 0 ? void 0 : _b.hasBackground,
            },
            variants: [configuration.variant],
            defaultVariantKey: configuration.variant.id,
        });
        block.properties = configuration.properties;
        return block;
    }
    /** Create block item with multiple variants of rendering. The first variant becomes the default one */
    multiVariantItem(configuration) {
        var _a, _b, _c, _d;
        const block = new DocsBlockItemDefinition({
            properties: [],
            appearance: {
                isBordered: (_b = (_a = configuration.appearance) === null || _a === void 0 ? void 0 : _a.isBordered) !== null && _b !== void 0 ? _b : true,
                hasBackground: (_d = (_c = configuration.appearance) === null || _c === void 0 ? void 0 : _c.hasBackground) !== null && _d !== void 0 ? _d : false,
            },
            variants: configuration.variants,
            defaultVariantKey: configuration.variants[0].id,
        });
        block.properties = configuration.properties;
        return block;
    }
    /** Creates a core block definition which can't select from Supernova data, and its item can only be created once (Examples: Rich Text, Callout, Heading blocks) */
    singleItemBlock(configuration) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return new DocsBlockDefinition({
            id: configuration.id,
            name: configuration.name,
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            description: configuration.description,
            category: configuration.category,
            icon: configuration.icon,
            // @ts-expect-error TS(2322): Type 'DocsBlockItem' is not assignable to type 'Do... Remove this comment to see the full error message
            item: configuration.item,
            searchKeywords: configuration.searchKeywords,
            behavior: {
                dataType: DocsBlockBehaviorDataType.item,
                items: {
                    numberOfItems: 1,
                    allowLinks: (_a = configuration.linkable) !== null && _a !== void 0 ? _a : false,
                },
            },
            appearance: {
                isBordered: (_c = (_b = configuration.appearance) === null || _b === void 0 ? void 0 : _b.isBordered) !== null && _c !== void 0 ? _c : true,
                hasBackground: (_e = (_d = configuration.appearance) === null || _d === void 0 ? void 0 : _d.hasBackground) !== null && _e !== void 0 ? _e : false,
                isEditorPresentationDifferent: (_g = (_f = configuration.appearance) === null || _f === void 0 ? void 0 : _f.isEditorPresentationDifferent) !== null && _g !== void 0 ? _g : false,
                showBlockHeaderInEditor: (_j = (_h = configuration.appearance) === null || _h === void 0 ? void 0 : _h.showBlockHeaderInEditor) !== null && _j !== void 0 ? _j : false,
            },
            editorOptions: {
                // @ts-expect-error TS(2322): Type 'DocsBlockOnboarding | undefined' is not assi... Remove this comment to see the full error message
                onboarding: configuration.onboarding,
            },
        });
    }
    /** Creates a core block definition which can't select from Supernova data, and its items can be created multiple times (Examples: Shortcuts block) */
    multiItemBlock(configuration) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return new DocsBlockDefinition({
            id: configuration.id,
            name: configuration.name,
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            description: configuration.description,
            category: configuration.category,
            icon: configuration.icon,
            // @ts-expect-error TS(2322): Type 'DocsBlockItem' is not assignable to type 'Do... Remove this comment to see the full error message
            item: configuration.item,
            searchKeywords: configuration.searchKeywords,
            behavior: {
                dataType: DocsBlockBehaviorDataType.item,
                items: {
                    numberOfItems: (_a = configuration.maxItems) !== null && _a !== void 0 ? _a : -1,
                    allowLinks: (_c = (_b = configuration.options) === null || _b === void 0 ? void 0 : _b.linkable) !== null && _c !== void 0 ? _c : false,
                    newItemLabel: (_e = (_d = configuration.options) === null || _d === void 0 ? void 0 : _d.newItemLabel) !== null && _e !== void 0 ? _e : undefined,
                },
            },
            appearance: {
                isBordered: (_g = (_f = configuration.appearance) === null || _f === void 0 ? void 0 : _f.isBordered) !== null && _g !== void 0 ? _g : true,
                hasBackground: (_j = (_h = configuration.appearance) === null || _h === void 0 ? void 0 : _h.hasBackground) !== null && _j !== void 0 ? _j : false,
                isEditorPresentationDifferent: (_l = (_k = configuration.appearance) === null || _k === void 0 ? void 0 : _k.isEditorPresentationDifferent) !== null && _l !== void 0 ? _l : false,
                showBlockHeaderInEditor: (_o = (_m = configuration.appearance) === null || _m === void 0 ? void 0 : _m.showBlockHeaderInEditor) !== null && _o !== void 0 ? _o : false,
            },
            editorOptions: {
                // @ts-expect-error TS(2322): Type 'DocsBlockOnboarding | undefined' is not assi... Remove this comment to see the full error message
                onboarding: configuration.onboarding,
            },
        });
    }
    /** Creates a core block definition which will be allowed to select from Supernova data (Examples: Token, Asset block) */
    dataBlock(configuration) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return new DocsBlockDefinition({
            id: configuration.id,
            name: configuration.name,
            category: configuration.category,
            icon: configuration.icon,
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            description: configuration.description,
            // @ts-expect-error TS(2322): Type 'DocsBlockItem' is not assignable to type 'Do... Remove this comment to see the full error message
            item: configuration.item,
            searchKeywords: configuration.searchKeywords,
            behavior: {
                dataType: configuration.dataType,
                entities: {
                    selectionType: configuration.selectionType,
                    maxSelected: (_a = configuration.maxSelection) !== null && _a !== void 0 ? _a : 0,
                },
            },
            appearance: {
                isBordered: (_c = (_b = configuration.appearance) === null || _b === void 0 ? void 0 : _b.isBordered) !== null && _c !== void 0 ? _c : true,
                hasBackground: (_e = (_d = configuration.appearance) === null || _d === void 0 ? void 0 : _d.hasBackground) !== null && _e !== void 0 ? _e : false,
                isEditorPresentationDifferent: (_g = (_f = configuration.appearance) === null || _f === void 0 ? void 0 : _f.isEditorPresentationDifferent) !== null && _g !== void 0 ? _g : false,
                showBlockHeaderInEditor: (_j = (_h = configuration.appearance) === null || _h === void 0 ? void 0 : _h.showBlockHeaderInEditor) !== null && _j !== void 0 ? _j : false,
            },
            editorOptions: {
                // @ts-expect-error TS(2322): Type 'DocsBlockOnboarding | undefined' is not assi... Remove this comment to see the full error message
                onboarding: configuration.onboarding,
            },
        });
    }
    /** Creates onboarding entity */
    onboarding(configuration) {
        return new DocsBlockOnboarding({
            helpText: configuration.helpText,
            documentationLink: configuration.documentationLink,
        });
    }
    /** Create a block property with type .text and its specific options */
    textProperty(configuration) {
        return new DocsBlockTextPropertyDefinition({
            type: DocsBlockItemPropertyType.text,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .richText and its specific options */
    richTextProperty(configuration) {
        return new DocsBlockRichTextPropertyDefinition({
            type: DocsBlockItemPropertyType.richText,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .multiRichText and its specific options */
    multiRichTextProperty(configuration) {
        return new DocsBlockRichTextPropertyDefinition({
            type: DocsBlockItemPropertyType.richText,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .multiRichText and its specific options */
    richTextEditorProperty(configuration) {
        return new DocsBlockRichTextEditorPropertyDefinition({
            type: DocsBlockItemPropertyType.richTextEditor,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .boolean and its specific options */
    booleanProperty(configuration) {
        return new DocsBlockBooleanPropertyDefinition({
            type: DocsBlockItemPropertyType.boolean,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .number and its specific options */
    numericProperty(configuration) {
        return new DocsBlockNumberPropertyDefinition({
            type: DocsBlockItemPropertyType.number,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .singleSelect and its specific options */
    singleSelectProperty(configuration) {
        return new DocsBlockSingleSelectPropertyDefinition({
            type: DocsBlockItemPropertyType.singleSelect,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .multiSelect and its specific options */
    multiSelectProperty(configuration) {
        return new DocsBlockMultiSelectPropertyDefinition({
            type: DocsBlockItemPropertyType.multiSelect,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .image and its specific options */
    imageProperty(configuration) {
        return new DocsBlockImagePropertyDefinition({
            type: DocsBlockItemPropertyType.image,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .token and its specific options */
    tokenProperty(configuration) {
        return new DocsBlockTokenPropertyDefinition({
            type: DocsBlockItemPropertyType.token,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .tokenType and its specific options */
    tokenTypeProperty(configuration) {
        return new DocsBlockTokenTypePropertyDefinition({
            type: DocsBlockItemPropertyType.tokenType,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .tokenProperty and its specific options */
    tokenPropertyProperty(configuration) {
        return new DocsBlockTokenPropertyPropertyDefinition({
            type: DocsBlockItemPropertyType.tokenProperty,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .component and its specific options */
    componentProperty(configuration) {
        return new DocsBlockComponentPropertyDefinition({
            type: DocsBlockItemPropertyType.component,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .componentProperty and its specific options */
    componentPropertyProperty(configuration) {
        return new DocsBlockComponentPropertyPropertyDefinition({
            type: DocsBlockItemPropertyType.componentProperty,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .figmaComponentProperty and its specific options */
    figmaComponentProperty(configuration) {
        return new DocsBlockFigmaComponentPropertyDefinition({
            type: DocsBlockItemPropertyType.figmaComponent,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .asset and its specific options */
    assetProperty(configuration) {
        return new DocsBlockAssetPropertyDefinition({
            type: DocsBlockItemPropertyType.asset,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .figmaNodeProperty and its specific options */
    figmaNodeProperty(configuration) {
        return new DocsBlockFigmaNodePropertyDefinition({
            type: DocsBlockItemPropertyType.figmaNode,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .assetProperty and its specific options */
    assetPropertyProperty(configuration) {
        return new DocsBlockAssetPropertyPropertyDefinition({
            type: DocsBlockItemPropertyType.assetProperty,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .embedURL and its specific options */
    embedUrlProperty(configuration) {
        return new DocsBlockEmbedUrlPropertyDefinition({
            type: DocsBlockItemPropertyType.embedURL,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .markdown and its specific options */
    markdownProperty(configuration) {
        return new DocsBlockMarkdownPropertyDefinition({
            type: DocsBlockItemPropertyType.markdown,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .url and its specific options */
    urlProperty(configuration) {
        return new DocsBlockUrlPropertyDefinition({
            type: DocsBlockItemPropertyType.url,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .storybook and its specific options */
    storybookProperty(configuration) {
        return new DocsBlockStorybookPropertyDefinition({
            type: DocsBlockItemPropertyType.storybook,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .code and its specific options */
    codeProperty(configuration) {
        return new DocsBlockCodePropertyDefinition({
            type: DocsBlockItemPropertyType.code,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .codeSandbox and its specific options */
    codeSandboxProperty(configuration) {
        return new DocsBlockCodeSandboxPropertyDefinition({
            type: DocsBlockItemPropertyType.codeSandbox,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .table and its specific options */
    tableProperty(configuration) {
        return new DocsBlockTablePropertyDefinition({
            type: DocsBlockItemPropertyType.table,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
    /** Create a block property with type .divider and its specific options */
    dividerProperty(configuration) {
        return new DocsBlockDividerPropertyDefinition({
            type: DocsBlockItemPropertyType.divider,
            id: configuration.id,
            name: configuration.name,
            description: configuration.description,
            options: configuration.options,
            variantOptions: configuration.variants,
        });
    }
}
